import { Text } from "@imminently/react/ui/core/text";

export const BulletPoint = () => (
  <Text fontSize="10px" display="inline-block" padding="5px 15px 5px 15px">
    •
  </Text>
);
